export const SIDEBAR_WIDTHS = {
  COLLAPSED: 'w-14.75',
  EXPANDED: 'w-79',
}

export const SIDEBAR_MOBILE_BREAKPOINT = 768

export const MENU_ITEM_STYLES = {
  HEIGHT: 'h-8',
  ICON_WIDTH: 'w-5.5',
  BUTTON_WIDTH: 'w-8',
}

export const TRANSITION_DURATIONS = {
  SIDEBAR: 'duration-300',
  OPACITY: 'duration-150',
  CHEVRON: 'duration-300',
}

export const SPACING = {
  HEADER_GAP: 'gap-2.5',
  MENU_GAP: 'gap-4.5',
  HEADER_PADDING: 'py-2 px-3',
  MENU_PADDING: 'py-5 px-3',
}

export const AUTHORIZED_TENANTS = {
  CONSULTANT_SITE_VISIT: [
    'dss',
    'dss-dev',
    'dss-qa',
    'dss-stg',
  ],
}

export const COMPANY_IDENTIFIERS = {
  ADECOAGRO: 'adecoagro',
  POSCO: 'posco',
}

export const MODULE_NAMES = {
  STOP_SAFETY_OBSERVATION: 'core.menu.modules.stop-safety-observation',
  STOP_SAFETY_OBSERVATION_ADECOAGRO: 'core.menu.modules.stop-safety-observation-adecoagro',
  CONSULTANT_SITE_VISIT: 'core.menu.modules.consultant-site-visit',
  CONSULTANT_SITE_VISIT_IMAGE_INBOX: 'core.menu.modules.consultant-site-visit-image-inbox',
}

export const MENU_OVERVIEW_NAME = 'core.menu.main.overview'

export const ROUTE_NAMES = {
  DASHBOARD_VIEWER: 'Dashboard Viewer',
  CONSULTANT_VISIT_DASHBOARDS: 'consultant-visit-dashboards',
  CONSULTANT_VISIT_IMAGE_INBOX: 'consultant-visit-image-inbox',
}
